module.exports = __webpack_public_path__ + "static/media/close.3287d96e.svg";